/**
 * axios setup to use mock service
 */

import axios from "axios";

// Create axios instance with correct backend base URL
const axiosServices = axios.create({
  baseURL: "https://api.moofunk169.com/", // Correct backend port
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor
axiosServices.interceptors.request.use(
  (config) => {
    const serviceToken = localStorage.getItem("serviceToken");
    if (serviceToken) {
      config.headers.Authorization = serviceToken;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle session invalidation
axiosServices.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      error.response?.data?.code === "SESSION_INVALIDATED"
    ) {
      // Handle session invalidation
      localStorage.removeItem("serviceToken");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default axiosServices;
